import React from 'react';
import {
  ProductOperationsComponent,
  ProductDevelopmentComponent,
  ProductProjectionsComponent,
  MarketFitComponent,
} from '../../components/Dashboard/ReportingComponents';
import styles from './ProductDashboard.module.css';

type Subdomain = 'operations' | 'development' | 'projections' | 'marketfit';

export type ProductDashboardDetailSectionProps = {
  productId: string;
  selectedSubdomain: Subdomain;
  localBridgeEnabled: boolean;
  onDrillDownToOperations: () => void;
  onDealSelect: (dealId: string, dealName?: string) => void;
  onSituationSelect: (situationId: string) => void;
  onSolutionSelect: (solutionId: string) => void;
};

export function ProductDashboardDetailSection({
  productId,
  selectedSubdomain,
  localBridgeEnabled,
  onDrillDownToOperations,
  onDealSelect,
  onSituationSelect,
  onSolutionSelect,
}: ProductDashboardDetailSectionProps) {
  return (
    <div className={styles.detailSection}>
      {selectedSubdomain === 'operations' && (
        <ProductOperationsComponent
          artifactId={productId}
          onDrillDown={onDrillDownToOperations}
        />
      )}
      {selectedSubdomain === 'development' && (
        <ProductDevelopmentComponent
          artifactId={productId}
          compact={false}
          showControls={false}
        />
      )}
      {selectedSubdomain === 'projections' && (
        <ProductProjectionsComponent
          artifactId={productId}
          compact={false}
          showControls={false}
        />
      )}
      {selectedSubdomain === 'marketfit' && (
        <MarketFitComponent
          artifactId={productId}
          compact={false}
          showControls={false}
          onDealSelect={localBridgeEnabled ? onDealSelect : undefined}
          onSituationSelect={localBridgeEnabled ? onSituationSelect : undefined}
          onSolutionSelect={localBridgeEnabled ? onSolutionSelect : undefined}
        />
      )}
    </div>
  );
}
